// extracted by mini-css-extract-plugin
module.exports = {"practicalRoot":"_01c763d3","codeRoot":"_273017f6","theoryRoot":"_6d62c28c","practicalTitle":"ae68aaf0","codeTitle":"_5ad9e931","theoryTitle":"_7b2eeb8d"};